export default angular.module("CompilerService", []).factory("Compiler", [
  "$http",
  function ($http) {
    const compileAll = () =>
      $http
        .get("/api/compile/");

    const status = () =>
      $http
        .get("/api/compile/status");

    return {
      compileAll,
      status,
    };
  },
]);
